import React from 'react';
import { motion } from 'framer-motion';
import { History } from 'lucide-react';
import { SectionHeader } from './shared/SectionHeader';
import { CollapsibleSection } from './shared/CollapsibleSection';
import { ChannelRevenuePivot } from './historical/ChannelRevenuePivot';
import { MonthlyPerformanceAccordion } from './historical/MonthlyPerformanceAccordion';
import { PlatformCategoryBreakdown } from './historical/PlatformCategoryBreakdown';
import { GaMonthlySummary } from './historical/GaMonthlySummary';
import { WeeklyHeatmap } from './historical/WeeklyHeatmap';
import { WeekOverWeekSummary } from './historical/WeekOverWeekSummary';

export function HistoricalData({
  monthlyPerformanceData, monthlyPlatformCategoryData, channelMonthlyRevenue,
  gaMonthlySummary, weeklyRevenueByWeekday, weeklyWoWSummary,
  allCostsByMonth, totalAllCosts, weeklyMetric, onWeeklyMetricChange,
  isVisible,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5 }}
      className="mb-6"
    >
      <SectionHeader title="Historical Data" icon={History} subtitle="All-time performance metrics" />

      <CollapsibleSection title="Channel Revenue Pivot">
        <ChannelRevenuePivot channelMonthlyRevenue={channelMonthlyRevenue} />
      </CollapsibleSection>

      <CollapsibleSection title="Monthly Performance">
        <MonthlyPerformanceAccordion monthlyPerformanceData={monthlyPerformanceData} />
      </CollapsibleSection>

      {isVisible && (
        <CollapsibleSection title="Platform Category Breakdown">
          <PlatformCategoryBreakdown monthlyPlatformCategoryData={monthlyPlatformCategoryData} />
        </CollapsibleSection>
      )}

      <CollapsibleSection title="GA Monthly Summary">
        <GaMonthlySummary gaMonthlySummary={gaMonthlySummary} allCostsByMonth={allCostsByMonth} totalAllCosts={totalAllCosts} />
      </CollapsibleSection>

      <CollapsibleSection title="Weekly Heatmap">
        <WeeklyHeatmap
          weeklyRevenueByWeekday={weeklyRevenueByWeekday}
          weeklyMetric={weeklyMetric}
          onWeeklyMetricChange={onWeeklyMetricChange}
        />
      </CollapsibleSection>

      <CollapsibleSection title="Week-over-Week Summary">
        <WeekOverWeekSummary weeklyWoWSummary={weeklyWoWSummary} weeklyMetric={weeklyMetric} />
      </CollapsibleSection>
    </motion.div>
  );
}
